import { CheckoutAmountRequestProps } from "@utils/getCheckoutAmountRequestData";
import { CheckoutCompleteProps } from "@context/CheckContext";
import { ErrorType } from "@component/PaymentDetails/PaymentDetails";
import apiClient from "@utils/api/apiClient";
import { isFalsy } from "@utils/truthy";

export interface CheckoutErrorResponse {
    message: {
        code: number;
        message: string;
    };
}

export interface HandleCheckoutErrorProps {
    response: CheckoutErrorResponse;
    checkoutAmountRequest: CheckoutAmountRequestProps;
    sessionGuid?: string;
    totalPaidInCents?: number;
    setCheckoutComplete?: (props: CheckoutCompleteProps) => void;
    toCompletePage: (checkoutAmountRequest: CheckoutAmountRequestProps, successResponse: CheckoutCompleteProps) => void;
    setError: React.Dispatch<React.SetStateAction<ErrorType | undefined>>;
    setIsProcessingCheckout?: React.Dispatch<React.SetStateAction<boolean>>;
    setProcessNonAmexPayment?: React.Dispatch<React.SetStateAction<boolean>>;
    placeCode: string,
    ticketId:string,
    checkoutId : string,
    applePaySession? : ApplePaySession
}


async function HandleCheckoutError(
  {
    response,
    checkoutAmountRequest,
    sessionGuid,
    totalPaidInCents,
    setCheckoutComplete,
    toCompletePage,
    setError,
    setIsProcessingCheckout,
    setProcessNonAmexPayment,
    placeCode,
    ticketId,
    checkoutId,
    applePaySession
  }: HandleCheckoutErrorProps): Promise<void> {
    const isAlreadyProcessed =
        response?.message?.code === 417 &&
        (response?.message?.message.includes("Transaction already processed") ||
            response?.message?.message.includes(" Ticket is already closed, hence cannot checkout"));


    if (isAlreadyProcessed) {

        if (applePaySession) {
            applePaySession.completePayment(ApplePaySession.STATUS_SUCCESS);
        }

        let successResponse: CheckoutCompleteProps = {
          charged: false,
          cardType: "",
          sessionGuid,
          totalPaidInCents,
          financialTransactionId: "",
        };

        if(isFalsy(sessionGuid))
        {
             successResponse  =  await apiClient.get({ path: `/checkout/result/${placeCode}/${checkoutId}/${ticketId}` });
        }

        if (setCheckoutComplete) {
            // for visa card payments
            setCheckoutComplete(successResponse);
        }
        // for visa card , google pay and apple pay payments
        toCompletePage(checkoutAmountRequest, successResponse);

    } else {
       setError("checkoutError");

        if (setIsProcessingCheckout) {
            // for visa card payments
            setIsProcessingCheckout(false);
        }
        if (setProcessNonAmexPayment) {
            // for visa card payments
            setProcessNonAmexPayment(false);
        }
    }
};

export default HandleCheckoutError;
